<template>
  <a-tabs default-active-key="1">
    <a-tab-pane key="1">
    <span slot="tab">
      <a-icon type="cloud-upload"/>
      Carpeta
    </span>
    <a-card>
      <div v-if="$getConfigValue('MOSTRAR_ALERTA_CARGUE_DOC', 'NO') === 'SI'">
        <a-alert
          :message="$getConfigValue('MENSAJE1_ALERTA_CARGUE_DOC')"
          :description="$getConfigValue('MENSAJE2_ALERTA_CARGUE_DOC')"
          type="info"
          show-icon
        />
        <br>
      </div>
      <g-master name="biodatacarguedocumentacion"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                :parentData="master.parentData"
                :actions="master.actions"
                @action="masterAction"
                ref="masterComponent">
      </g-master>
      <a-modal title="Cargue de documentos obligatorios"
               :visible="modalDocObligatorioVisible"
               @ok="aceptarModalDocObligatorio"
               :confirmLoading="modalDocObligatorioLoading"
               @cancel="cancelarModalDocObligatorio"
               :dialogStyle="{top: '20px'}"
               width="90%">
        <a-spin :spinning="modalDocObligatorioLoading">
          <a-row>
            <a-form-model layout="inline">
              <a-form-model-item :label="$t('Documentos disponibles')" has-feedback>
                <form-model-dropdown style="width: 250px"
                                     endpoint="hierarchy_lookup"
                                     v-model="docSeleccionado"
                                     :selectedObj.sync="docSeleccionadoObj"
                                     :params="{h_lookup_type: 'DOCUMENTOS_HV'}">
                </form-model-dropdown>
              </a-form-model-item>
              <a-form-model-item>
                <a-button @click="agregarDocumento">
                  <a-icon type="plus"></a-icon>
                </a-button>
              </a-form-model-item>
            </a-form-model>
          </a-row>
          &nbsp;
          <a-row :gutter="[16,16]">
            <a-form-model :model="formData">

              <template v-for="doc in documentosSeleccionados">
                <a-col :md="3" style="max-height: 28px; overflow: hidden">
                  <a-tooltip title="Eliminar" v-if="doc.eliminable">
                    <a-icon type="delete" style="color:red;"
                            @click="eliminarDocumento(doc.id_h_lookup)"/>
                  </a-tooltip>
                  <a-tooltip title="Requerido" v-else>
                    <a-badge status="error"/>
                  </a-tooltip>
                  <a-tooltip :title="doc.description">
                    {{doc.description}}
                  </a-tooltip>
                </a-col>
                <a-col :md="1" style="max-height: 40px; overflow: hidden">
                  <a-upload
                    name="file"
                    :multiple="false"
                    :beforeUpload="(file, fileList) => beforeFileUpload(doc.id_h_lookup, file)"
                    :remove="(file, fileList) => removeFileUpload(doc.id_h_lookup, file)">
                    <a-button>
                      <a-icon type="upload" v-if="formData['d_'+doc.id_h_lookup+'_file'] !== true"></a-icon>
                      <a-icon type="check" v-if="formData['d_'+doc.id_h_lookup+'_file'] === true"
                              style="color: green"></a-icon>
                    </a-button>
                  </a-upload>
                </a-col>
                <a-col :md="3">
                  <a-input placeholder="Descripción"
                           v-model="formData['d_'+doc.id_h_lookup+'_description']"
                           class="ant-uppercase"
                  ></a-input>
                </a-col>
                <a-col :md="3">
                  <a-input placeholder="Número de documento"
                           v-model="formData['d_'+doc.id_h_lookup+'_num_doc']"
                           class="ant-uppercase"
                  ></a-input>
                </a-col>
                <a-col :md="3">
                  <form-model-lookup style="width: 100%"
                                     endpoint="hierarchy_lookup"
                                     v-model="formData['d_'+doc.id_h_lookup+'_id_h_city_expedition']"
                                     placeholder="Ciudad de Expedición"
                                     :params="{h_lookup_type: 'CIUDADES_HV'}">
                  </form-model-lookup>
                </a-col>
                <a-col :md="3">
                  <a-date-picker placeholder="Fecha Expedición"
                                 v-model="formData['d_'+doc.id_h_lookup+'_expedition_date']"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                  ></a-date-picker>
                </a-col>
                <a-col :md="3">
                  <a-date-picker placeholder="Fecha Expiración"
                                 v-model="formData['d_'+doc.id_h_lookup+'_expiration_date']"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                  ></a-date-picker>
                </a-col>
                <a-col :md="3">
                  <form-model-dropdown style="width: 100%"
                                       endpoint="hierarchy_lookup"
                                       v-model="formData['d_'+doc.id_h_lookup+'_id_h_district']"
                                       placeholder="Distrito"
                                       :params="{h_lookup_type: 'DISTRITO'}">
                  </form-model-dropdown>
                </a-col>
                <a-col :md="2">
                  <form-model-dropdown style="width: 100%"
                                       endpoint="hierarchy_lookup"
                                       v-model="formData['d_'+doc.id_h_lookup+'_id_h_class']"
                                       placeholder="Clase"
                                       :params="{h_lookup_type: 'CLASE_LIBRETA_MILITAR'}">
                  </form-model-dropdown>
                </a-col>
              </template>
            </a-form-model>
          </a-row>
        </a-spin>
      </a-modal>
    </a-card>
    </a-tab-pane>
  </a-tabs>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import JsUtils from '@/util/JsUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    props: ['persona'],
    data () {
      return {
        loadingBtns: {},
        master: {
          endpoint: 'person_doc',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_person_doc'
            },
            columns: [
              {title: 'Tipo de documento', dataIndex: 'h_type_doc', sorter: true},
              {title: 'Descripción', dataIndex: 'description', sorter: true},
              {title: 'Numero de documento', dataIndex: 'num_doc', sorter: true},
              {title: 'Ciudad de expedicion', dataIndex: 'h_city_expedition', sorter: true},
              {title: 'Fecha de expedicion', dataIndex: 'expedition_date_desc', sorter: true},
              {title: 'Fecha de expiración', dataIndex: 'expiration_date_desc', sorter: true},
              {title: 'Clase', dataIndex: 'h_class', sorter: true},
              {title: 'Distrito', dataIndex: 'h_district', sorter: true},
              {title: 'Principal', dataIndex: 'principal', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by'},
              {title: 'Creado', dataIndex: 'created_on'},
              {title: 'Modificado por', dataIndex: 'modified_by'},
              {title: 'Modificado', dataIndex: 'modified_on'}
            ],
            actions: {
              actions: [
                {
                  name: 'download',
                  text: 'Descargar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'download', style: 'color: red'},
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id_person_doc] === record.id_person_doc
                  },
                  fnVisible: () => !this.$userIsInrol('Query')
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'},
                  fnVisible: () => !this.$userIsInrol('Query')
                }
              ]
            }
          },
          modalFieldsSetup: [
            {name: 'id_h_type_doc'},
            {name: 'description'},
            {name: 'num_doc'},
            {name: 'id_h_city_expedition'},
            {name: 'expedition_date', type: 'date'}
          ],
          actions: [
            {
              name: 'docObligatorio',
              text: 'Cargar doc. obligatorios',
              permisos: [],
              props: {icon: 'plus', type: 'button'},
              fnVisible: () => !this.$userIsInrol('Query')
            }
          ],
          parentData: {
            id_person: this.persona
          }
        },
        modalDocObligatorioVisible: false,
        modalDocObligatorioLoading: false,
        documentosSeleccionados: [],
        docSeleccionado: undefined,
        docSeleccionadoObj: {},
        docSeleccionadoObj2: {},
        formData: {},
        formDataFiles: {}
      }
    },
    mounted () {
      this.httpClient = new HttpUtil('biodata/cargar_documentos_obligatorios')
    },
    methods: {
      beforeFileUpload (tipoDoc, file) {
        this.formData['d_' + tipoDoc + '_file'] = true
        this.formDataFiles['d_' + tipoDoc] = file
        this.$forceUpdate()
        return false
      },
      removeFileUpload (tipoDoc, file) {
        this.formData['d_' + tipoDoc + '_file'] = false
        this.formDataFiles['d_' + tipoDoc] = undefined
        this.$forceUpdate()
      },
      masterAction (action) {
        switch (action.action) {
          case 'docObligatorio':
            this.modalDocObligatorioVisible = true
            this.cargarDocumentosRequeridos()
            this.formData = {}
            this.formDataFiles = {}
            break
          case 'download':
            this.downloadFile(action.record)
            break
        }
      },

      downloadFile (record) {
        this.loadingBtns[record.id_person_doc] = record.id_person_doc
        this.loadingBtns = Object.assign({}, this.loadingBtns)

        this.httpClient.getInstance().post('biodata/person_doc', {
          id_person_doc: record.id_person_doc
        }, {responseType: 'arraybuffer'}).then((response) => {
          let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
          fileURL = window.URL.createObjectURL(fileURL)
          let fileLink = document.getElementById('file_link_elm')
          if (fileLink === null) {
            fileLink = document.createElement('a')
            fileLink.setAttribute('id', 'file_link_elm')
            document.body.appendChild(fileLink)
          }
          fileLink.setAttribute('href', fileURL)
          fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
          fileLink.click()
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible descargar el archivo.')
        }).then(() => {
          delete this.loadingBtns[record.id_person_doc]
          this.loadingBtns = Object.assign({}, this.loadingBtns)
        })
      },

      cargarDocumentosRequeridos () {
        this.modalDocObligatorioLoading = true
        this.httpClient.getInstance().get('biodata/documentos_obligatorios', {
          params: {
            id_person: this.persona
          }
        })
          .then(response => {
            this.documentosSeleccionados = []
            response.data.map(d => {
              d.eliminable = false
              this.documentosSeleccionados.push(d)
            })
          })
          .catch(() => {
            this.documentosSeleccionados = []
          })
          .then(() => {
            this.modalDocObligatorioLoading = false
          })
      },
      aceptarModalDocObligatorio () {
        let camposAEnviar = [
          'description',
          'num_doc',
          'id_h_city_expedition',
          'expedition_date',
          'expiration_date',
          'id_h_district',
          'id_h_class'
        ]
        let requestData = new FormData()
        requestData.append('id_person', this.persona)

        if (this.modalDocObligatorioLoading) return
        /* valida todos los documentos obligatorios */
        for (let i = 0; i < this.documentosSeleccionados.length; i++) {
          const documentosSeleccionado = this.documentosSeleccionados[i]
          if (!this.formData['d_' + documentosSeleccionado.id_h_lookup + '_file']) {
            Mensajes.error('Error', 'Por favor cargue todos los documentos seleccionados')
            return
          }
          /* agrego los campos */
          requestData.append('tipo_documentos_enviados[]', documentosSeleccionado.id_h_lookup)
          camposAEnviar.map(campo => {
            let prop = 'd_' + documentosSeleccionado.id_h_lookup + '_' + campo
            if (!JsUtils.isEmpty(this.formData[prop])) {
              requestData.append(prop, this.formData[prop])
            }
          })
          /* agrego el archivo */
          let fileProp = 'd_' + documentosSeleccionado.id_h_lookup
          if (this.formData[fileProp + '_file']) {
            requestData.append(fileProp + '_file', this.formDataFiles[fileProp])
          }
        }
        /* Prepara el upload de todos los documentos */
        this.modalDocObligatorioLoading = true
        this.httpClient.create(requestData,
          (response) => {
            Mensajes.success('Correcto', 'Se cargaron los documentos correctamente')
            this.modalDocObligatorioVisible = false
            this.$refs.masterComponent.$refs.datatable.loadData()
          }, () => {
            Mensajes.error('Error', 'No fue posible cargar los documentos.')
          })
          .then(() => {
            this.modalDocObligatorioLoading = false
          })
      },
      cancelarModalDocObligatorio () {
        if (this.modalDocObligatorioLoading) return
        this.modalDocObligatorioVisible = false
      },
      eliminarDocumento (id) {
        let idx = -1
        for (let i = 0; i < this.documentosSeleccionados.length; i++) {
          const documentosSeleccionado = this.documentosSeleccionados[i]
          if (documentosSeleccionado.id_h_lookup === id) {
            idx = i
            break
          }
        }
        if (idx > -1) {
          this.documentosSeleccionados.splice(idx, 1)
        }
      },
      agregarDocumento () {
        if (!JsUtils.isEmpty(this.docSeleccionadoObj)) {
          let existe = false
          for (let i = 0; i < this.documentosSeleccionados.length; i++) {
            const documentosSeleccionado = this.documentosSeleccionados[i]
            if (documentosSeleccionado.id_h_lookup === this.docSeleccionado) {
              existe = true
              break
            }
          }
          if (!existe) {
            this.documentosSeleccionados.push({
              eliminable: true,
              description: this.docSeleccionadoObj.text,
              id_h_lookup: this.docSeleccionadoObj.value,
              ...this.docSeleccionadoObj
            })
          }
          this.docSeleccionado = undefined
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Biodata/BiodataCargueDocumentacion.vue